import { Routes, RouterModule } from '@angular/router';
import { OrderDetailFrm } from './order.frm';
import { OrderList } from './order.list';

export const routes: Routes = [
    { path: 'page/orderlist', component: OrderList },
    {
        path: 'orderdetail/:id/:dmy',
        component: OrderDetailFrm,
        data: { shouldReuseRoute: false },
    },
    { path: '', redirectTo: 'page/orderlist', pathMatch: 'full' },
    {
        path: 'page/order',
        redirectTo: 'page/orderlist',
        pathMatch: 'full',
    },
];

export const ORDER_ROUTER_PROVIDERS = RouterModule.forRoot(routes);
